module.exports = __webpack_public_path__ + "img/vlonder boven vijver.8a01fbef.jpg";